import { render, staticRenderFns } from "./meritDetailsForHR.vue?vue&type=template&id=f8025614&"
import script from "./meritDetailsForHR.vue?vue&type=script&lang=js&"
export * from "./meritDetailsForHR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports